import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const tsdResponseContract = c.router({
  postTsdResponse: {
    method: 'POST',
    path: '/pnts-response',
    body: z.record(z.any()),
    responses: {
      200: z.object({ data: z.record(z.any()) }),
    },
  },
});
